import React from 'react';
import clsx from 'clsx';

import { Icon } from '../Icon';

import {
  DropdownMenuBaseItem,
  DropdownMenuBaseItemProps
} from './DropdownMenuBaseItem';

export interface DropdownMenuItemProps extends DropdownMenuBaseItemProps {
  /**
   * Значение правого счетчика
   */
  badge?: number;
  /**
   * Иконка слева DropdownMenuItem
   * @type React.ElementType
   */
  leftIcon?: React.ElementType;
  /**
   * Иконка справа DropdownMenuItem
   * @type React.ElementType
   */
  rightIcon?: React.ElementType;
}

export const DropdownMenuItem = React.forwardRef<
  HTMLDivElement,
  DropdownMenuItemProps
>(({ badge, leftIcon, rightIcon, className, ...props }, ref) => {
  const { selected, hovered } = props;
  return (
    <DropdownMenuBaseItem
      ref={ref}
      className={clsx('hse-DropdownMenuItem', className, {
        'hse-DropdownMenuItem_selected': selected,
        'hse-DropdownMenuItem_hovered': hovered
      })}
      leftComponent={leftIcon && Icon}
      leftComponentProps={{
        className: 'hse-DropdownMenuItem__leftIcon',
        icon: leftIcon
      }}
      rightComponent={rightIcon && Icon}
      rightComponentProps={{
        className: 'hse-DropdownMenuItem__rightIcon',
        icon: rightIcon
      }}
      right={
        badge && <div className="hse-DropdownMenuItem__badge">{badge}</div>
      }
      {...props}
    />
  );
});
